import { url } from "inspector";
import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player";
import { Link, useHistory } from "react-router-dom";
import ImgPlaceHolder from "../../constant/imgPlaceholder";
import { ROUTE } from '../../route/Route';
import { useTranslation } from "react-i18next";
import WhyOncq from "./WhyOncq";
import SectionLoader from "../../Component/LodingScreen/SectionLoader";
import { useSelector } from "react-redux";
import { replaceImgUriByLang } from "../../constant/utils";

function InnerFitness(props: any) {
  const { t } = useTranslation();
  const { packages, baseUri } = props;
  const history = useHistory();
  const [isShown, setIsShown] = useState<number>(1);
  const dashboard: any = useSelector((state: any) => state.dashboard.dashboardData || null);

  return (
    <section className="categories section home-fitness">
      <div className="container">
        <WhyOncq />
        <div className="headingmains text-center pb-3">
          <h2 className="right aos-init pb-2">{t("inner_fitness_package")}</h2>
          <p className="text-center pl-2 pr-2">
            {t("inner_fitness_content")}
          </p>
          <p className="text-center">
            <button onClick={(e: any) => { e.preventDefault(); history.push(ROUTE.PREVENTIVEHEALTHPKJ, {  scrollToSection: true ,tabs: "packages" }) }} className="btn explorebtnfitness">
              <span>
                {t("explore_all")}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41.403"
                  height="26.331"
                  viewBox="0 0 41.403 26.331"
                >
                  <path
                    id="Icon_material-arrow-forward"
                    data-name="Icon material-arrow-forward"
                    d="M16.768,6l-2.32,2.32,9.183,9.2h-35.1v3.291h35.1l-9.183,9.2,2.32,2.32L29.933,19.166Z"
                    transform="translate(11.47 -6)"
                    fill="#424242"
                  ></path>
                </svg>
              </span>
            </button>
          </p>
        </div>
        <div className="all-center sub-section pb-0">
          <div className="col-md-12 all-center pb-5">
            <div className="fitness-wraph">
              <div className="flex-container flex-container-mob">
                {dashboard && Object.keys(dashboard)?.length > 0 ?
                  <>
                    {packages && packages?.length > 0 && packages?.map((item: any, index: any) => {
                      let img = item?.Banner ? replaceImgUriByLang(baseUri)+ item?.Banner : `/assets/img/f${(index + 2)}.png`;
                      return (
                        index < 7 &&
                        <div
                          key={index}
                          style={{ backgroundImage: `url(${img}), url(${baseUri+item?.Banner})`, backgroundRepeat: "no-repeat", backgroundColor: "#EDF3F8" }}
                          className={
                            isShown == index + 1
                              ? `flex-slide fit1 flex-slidehover`
                              : `flex-slide fit1`
                          }
                          onMouseEnter={() => setIsShown(index + 1)}
                          onClick={() => history.push(`${ROUTE.PACKAGEDETAILS}/${item?.Slug}`)}
                        >
                          <h6 className="flex-title flex-title-home">{t(item?.PackageName)}</h6>
                        </div>
                      )
                    })}
                  </>
                  :
                  <SectionLoader />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default InnerFitness;
